import script from "./Culture.vue?vue&type=script&setup=true&lang=js"
export * from "./Culture.vue?vue&type=script&setup=true&lang=js"

import "./Culture.vue?vue&type=style&index=0&id=0851c63e&scoped=true&lang=scss"

import exportComponent from "C:\\project\\OfficialWebsite360\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0851c63e"]])

export default __exports__